import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { lccstate, createNlsMiddleware, tapaneChangeProcess, recommended, childmap } from '@holmescorp/lcc-state';
import css from '../css/content-order.m.css';
import { difference } from '@holmescorp/collections';
const nls = createNlsMiddleware('ditabook');
const factory = create({ theme, nls, lccstate, recommended }).properties();
export const RecommendedOrder = factory(({ properties, middleware: { theme, lccstate, recommended } }) => {
    const themeCss = theme.classes(css);
    const { hideCompleted } = properties();
    const { get, path, run } = lccstate;
    const tracking = get(path('tracking'));
    let keySet;
    if (tracking) {
        const expandKeys = new Set(get(path('accordionSelected')));
        const localKeys = new Set(childmap.get(tracking.topichead));
        keySet = [...difference(expandKeys, localKeys), ...[tracking.topicset]];
    }
    const topic = recommended.topicsets(hideCompleted);
    const firstIncomplete = recommended.firstIncomplete();
    run(tapaneChangeProcess)({ accordionSelected: keySet ? keySet : [firstIncomplete] });
    return v('div', { key: 'recommended-order', xqa: `view recommended-order`, classes: [themeCss.root] }, [
        w('TopicAccordion', { topic })
    ]);
});
